import * as Styled from './Breadcrumb.styles'
import {
  ArrowLeftIcon,
  Button,
  Heading,
  WandSparklesIcon,
} from '@buffer-mono/popcorn'

/**
 *
 */
function Breadcrumb({
  onGoBack,
}: {
  onGoBack: (() => void) | null
}): JSX.Element {
  return (
    <Styled.Wrapper>
      {onGoBack && (
        <Button
          variant="tertiary"
          aria-label="Go back"
          data-testid="ai-assistant-back-button"
          onClick={onGoBack}
        >
          <ArrowLeftIcon />
        </Button>
      )}
      <Styled.ActiveItem>
        <WandSparklesIcon />
        <Heading as="h4">AI Assistant</Heading>
      </Styled.ActiveItem>
    </Styled.Wrapper>
  )
}

export { Breadcrumb }
